import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FileContext } from "../store/FileContextProvider";
import { LoaderContext } from "../store/LoaderContextProvider";
import { ScannerContext } from "../store/ScannerContextProvider";
import { ROUTES } from "../routes/routes";
import { actionWithSpinnerLoading } from "../utils/loaderUtils";

export function useXmlImport() {
  const { handleXmlFileImportWithScannerCheck } = useContext(FileContext);
  const { setIsloading } = useContext(LoaderContext);
  const { handleFocusOnScanner, scannerArray, isScanOn, startScan } = useContext(ScannerContext);
  const navigate = useNavigate();

  function importXmlFile(file: File, onFinish?: (isValidXml: boolean) => void) {
    handleXmlFileImportWithScannerCheck(file, scannerArray, (isValidXml) => {
      if (isValidXml) {
        if (!isScanOn) startScan();
        handleFocusOnScanner();
      }

      onFinish?.(isValidXml);
    });
  }
  function handleImportChangeNavigation(event: React.ChangeEvent<HTMLInputElement>, onInvalidXml?: () => void) {
    const file = event.target.files?.[0];
    if (!file) return;

    importXmlFile(file, (isValidXml) => {
      if (isValidXml) {
        navigate(ROUTES.checking);
        return;
      }

      onInvalidXml?.();
    });
  }

  function handleImportChangeWithSpinner(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file) return;

    actionWithSpinnerLoading({
      handleAction: () => importXmlFile(file),
      setIsLoading: setIsloading,
    });
  }

  return {
    handleImportChangeNavigation,
    handleImportChangeWithSpinner,
  };
}
